import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: '_.funding_requirements.header',
        defaultMessage:
            "You're drawing down {drawdownAmount} with repayments over {loanDuration}{tooltip}"
    },
    interestOnlyHeader: {
        id: '_.funding_requirements.interestOnlyHeader',
        defaultMessage: 'Your loan with repayments over {loanDuration}'
    },
    accessUserHeader: {
        id: '_.funding_requirements.accessUserHeader',
        defaultMessage:
            'You are guaranteeing a loan of {drawdownAmount} with repayments over {loanDuration}'
    },
    duration: {
        id: '_.funding_requirements.duration',
        defaultMessage: '{loanDuration} months'
    },
    tooltip: {
        id: '_.funding_requirements.tooltip',
        defaultMessage:
            "You can adjust your choice by clicking 'Go back' below."
    },
    subHeader: {
        id: '_.funding_requirements.subheader',
        defaultMessage:
            'Before we can send funds to your account, we need you to complete a few final steps.'
    },
    interestOnlySubHeader: {
        id: '_.funding_requirements.interestOnlySubHeader',
        defaultMessage:
            'Before we can extend your loan, you need to complete a few final steps'
    },
    repaymentReductionSubHeader: {
        id: '_.funding_requirements.repayment_reduction_subheader',
        defaultMessage:
            'Before we can reduce your monthly repayments, you need to complete a few final steps.'
    },
    accessUserSubHeader: {
        id: '_.funding_requirements.accessUserSubHeader',
        defaultMessage:
            'Before we can send funds to {businessName}, we need you to complete a few final steps.'
    },
    loadingText: {
        id: '_.funding_requirements.loading_text',
        defaultMessage: 'One moment, we’re checking your status...'
    },
    backButton: {
        id: '_.funding_requirements.back_button',
        defaultMessage: 'Go back'
    },
    incompleteTabTitle: {
        id: '_.funding_requirements.incomplete_tab_title',
        defaultMessage: 'Incomplete'
    },
    completeTabTitle: {
        id: '_.funding_requirements.complete_tab_title',
        defaultMessage: 'Complete'
    },
    selfServeRCTTitle: {
        id: '_.funding_requirements.self_serve_rct_title',
        defaultMessage: "You're all set for now"
    },
    selfServeRCTCaption: {
        id: '_.funding_requirements.self_serve_rct_caption',
        defaultMessage:
            "We're wrapping up some final checks and will be in touch soon."
    }
});
